(function(){
  if(window.__vtBuy) return; window.__vtBuy = true;
  /* mur de photos : le lazy-loading ne declenche pas pour les images hors ecran
     a droite d une piste animee. Des que la section entre en vue, on force le
     chargement de toute la piste. */
  function wakeWalls(){
    var walls = document.querySelectorAll(".vt-wall");
    if (!walls.length) return;
    var load = function(w){
      var im = w.querySelectorAll("img[loading='lazy']");
      for (var i=0;i<im.length;i++){ im[i].loading = "eager"; }
    };
    if (!("IntersectionObserver" in window)){
      for (var i=0;i<walls.length;i++) load(walls[i]); return;
    }
    var io2 = new IntersectionObserver(function(es){
      for (var i=0;i<es.length;i++){
        if (es[i].isIntersecting){ load(es[i].target); io2.unobserve(es[i].target); }
      }
    }, {rootMargin: "600px 0px"});
    for (var j=0;j<walls.length;j++) io2.observe(walls[j]);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", wakeWalls);
  else wakeWalls();
  document.addEventListener("shopify:section:load", wakeWalls);
  /* Delegated on document so it survives theme-editor section re-renders and
     any injection order. Lives in a theme ASSET, not in the template JSON, so a
     customizer save can never strip it. */
  var SEL = ['.nhb-bundles','.nhb-card','.product-form__quantity','quantity-input',
             '.quantity','variant-picker','.product-form__variants',
             '.product-form__buttons','product-form','.product-form','#vt-buybox'];
  function target(){
    var m = document.querySelector('#MainProduct, .shop-product-section, [id^="shopify-section"][id*="__main"]') || document;
    for (var i=0;i<SEL.length;i++){ var e = m.querySelector(SEL[i]); if (e) return e; }
    return m === document ? null : m;
  }


  /* carrousels (avis + ingredients) : fleches, defilement par carte */
  function slide(nav, wrapSel, trackSel, cardSel, attr){
    var wrap = nav.closest(wrapSel); if(!wrap) return;
    var tr = wrap.querySelector(trackSel); if(!tr) return;
    var card = tr.querySelector(cardSel);
    var gap = card ? parseFloat(getComputedStyle(tr).columnGap || 14) || 14 : 14;
    var step = card ? card.getBoundingClientRect().width + gap : tr.clientWidth;
    tr.scrollBy({left: nav.getAttribute(attr) === 'next' ? step : -step, behavior: 'smooth'});
  }
  document.addEventListener('click', function(ev){
    var r = ev.target.closest && ev.target.closest('[data-vt-rev]');
    if (r) return slide(r, '.vt-revs', '.vt-revs__track', '.vt-rev', 'data-vt-rev');
    var c = ev.target.closest && ev.target.closest('[data-vt-car]');
    if (c) return slide(c, '.vt-car', '.vt-car__track', '.vt-car__item', 'data-vt-car');
  });

  /* lightbox « Voir la composition » : ouverture/fermeture, Echap, clic hors cadre */
  document.addEventListener('click', function(ev){
    var open = ev.target.closest && ev.target.closest('[data-vt-facts]');
    if (open){ ev.preventDefault();
      var m = document.getElementById('vt-facts-modal');
      if (m){ m.setAttribute('open',''); document.body.style.overflow='hidden'; }
      return; }
    var m2 = document.getElementById('vt-facts-modal');
    if (!m2 || !m2.hasAttribute('open')) return;
    if (ev.target.closest('[data-vt-facts-close]') || ev.target === m2){
      m2.removeAttribute('open'); document.body.style.overflow=''; }
  });
  document.addEventListener('keydown', function(ev){
    if (ev.key !== 'Escape') return;
    var m = document.getElementById('vt-facts-modal');
    if (m && m.hasAttribute('open')){ m.removeAttribute('open'); document.body.style.overflow=''; }
  });

  document.addEventListener('click', function(ev){
    var b = ev.target.closest && ev.target.closest('[data-vt-buy],a[href$="#vt-buybox"]');
    if(!b) return;
    ev.preventDefault();
    var t = target(); if(!t) return;
    /* 'auto', not 'smooth': some themes disable smooth scrolling and the jump fails */
    window.scrollTo({top: t.getBoundingClientRect().top + window.pageYOffset - 90, behavior:'auto'});
    var f = t.querySelector('select,input[type="number"],button') || t;
    if (f && f.focus){ try { f.focus({preventScroll:true}); } catch(e){} }
  });
})();
